import React from 'react'
import clsx from 'clsx'

export default function Container({ children, maxWidth = 1430, style, className, horizontalSpacingClassName }) {
  return (
    <div
      className={clsx(
        'block w-full mx-auto box-border relative',
        className,
        horizontalSpacingClassName || 'px-4 md:px-6'
      )}
      style={{ maxWidth: maxWidth, ...style }}
    >
      {children}
    </div>
  )
}
